<div class="full-width has-nav">
  <img
    ngSrc="/logo/logo_black.svg"
    loading="lazy"
    alt="Logo les Explorateurs du Monde"
    width="100"
    height="100"
  />
  <h1>404: Tu es tombé sur une terre innexplorée</h1>
  <p>Retourne à la <a href="/">page d'accueil</a> pour en découvrir de nouvelles !</p>
  <a class="button" href="/">Retour à l'accueil</a>
</div>
